<template>
    <ul class="map-list">
        <li>
            <a href="http://www.gxzf.gov.cn/zwdt" target="_blank" rel="noopener noreferrer">
                <img src="../../../assets/icon/Map.png">
                <span>自治区的政务地图</span>
            </a>
        </li>

        <li>
            <a @click="change_cmpt('left_zrzyjfj_list')">
                <img src="../../../assets/icon/Agency.png">
                <span>自然资源局分局、县区局</span>
            </a>
        </li>

        <li>
            <a @click="change_cmpt('left_bdcsld_list')">
                <img src="../../../assets/icon/ReceptionPoint.png">
                <span>不动产受理点</span>
            </a>
        </li>

        <li>
            <a @click="change_cmpt('left_crjh_list')">
                <img src="../../../assets/icon/Notice.png">
                <span>2023年度“招拍挂”公开出让计划</span>
            </a>
        </li>

        <li>
            <a href="https://bdc.nngeo.com" target="_blank" rel="noopener noreferrer">
                <img src="../../../assets/icon/Platform.png">
                <span>不动产登记综合服务平台</span>
            </a>
        </li>

        <li>
            <a href="https://dz.nnrig.com/gateway/dpzs/" target="_blank" rel="noopener noreferrer">
                <img src="../../../assets/icon/Monitor.png">
                <span>南宁市地质灾害监测综合管理平台</span>
            </a>
        </li>

    </ul>
</template>
  
<script>
    export default {
        name: 'left_main_list',

        props: {

        },
        
        data () {
            return {
            
            }
        },

        methods: {
            //切换左栏页面组件方法：传入要切换的组件名
            change_cmpt(name){
                this.$emit('change_left_cmpt',name);
            }
        },
    }
</script>
  

<style scoped>

/* 左侧地图列表 */
.map-list{
  box-sizing: border-box;
  list-style-type: none;
  margin: 20px;
  padding: 0;
  line-height: 0px;
  text-align: left;
}

.map-list li{
  position: relative;
  text-align: center;
  display: inline-block;
  vertical-align: middle;
  width: 73px;
  height: 70px;
  margin-bottom: 38px;
  margin-left: 15px;
  cursor: pointer;
}

.map-list a{
  position: absolute;
  line-height: 15px;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size:12px;
  color: black;
  text-decoration :none;
}

.map-list a img{
    width: 40px;
}
.map-list a span{
    width: 100%;
    float: left;
}

</style>
  


// WEBPACK FOOTER //
// src/components/zwfwmap-pc/left_main_list/left_main_list.vue